import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { ToastComponent } from "../../Components/ToastComponent";

// #317: GET /routes/{id} foi removido do backend (confirmado pelo Reginaldo).
// Agora não buscamos mais o detalhe por id: a listagem (GET /routes) já traz
// todos os campos de cada rota, então recebemos a rota inteira por prop.
export default function RouteDetailsModal({ show, route, handleClose }) {
  const [toastParams, setToastParams] = useState("");
  const navigate = useNavigate();

  const showToast = (title, body, color = "success") =>
    setToastParams(JSON.stringify({ show: true, title, body, color }));

  const copyToClipboard = (text, label) => {
    if (!text) {
      showToast("Aviso", `${label} não disponível para esta rota.`, "warning");
      return;
    }
    navigator.clipboard
      .writeText(text)
      .then(() => showToast("Sucesso", `${label} copiado.`))
      .catch(() => showToast("Erro", `Não foi possível copiar ${label.toLowerCase()}.`, "danger"));
  };

  // Campos com fallback PascalCase/camelCase, mesma lógica de antes
  const data = route;
  const originName = data?.originName ?? data?.OriginName;
  const destinationName = data?.destinationName ?? data?.DestinationName;
  const intermediatePointsRaw = data?.intermediatePoints ?? data?.IntermediatePoints ?? "";
  const hasIntermediatePoints =
    typeof intermediatePointsRaw === "string"
      ? intermediatePointsRaw.trim().length > 0
      : Array.isArray(intermediatePointsRaw) && intermediatePointsRaw.length > 0;
  const mapLink = data?.mapLink ?? data?.MapLink;
  const instructions = data?.instructions ?? data?.Instructions;
  const vehicleType = data?.vehicleType ?? data?.VehicleType;

  const openRoutingWithVehicle = () => {
    if (!vehicleType) return;
    navigate("/routing/new", {
      state: {
        vehicleType,
      },
    });
  };

  return (
    <>
      <ToastComponent
        params={toastParams}
        closeToast={() => setToastParams(JSON.stringify({ show: false }))}
      />
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Detalhes da rota</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!data ? (
            <div className="text-secondary" style={{ fontSize: 13 }}>
              Não foi possível carregar os detalhes desta rota.
            </div>
          ) : (
            <>
              {vehicleType && (
                <p style={{ fontSize: 13 }}>
                  <strong>Veículo:</strong> {vehicleType}
                </p>
              )}
              <p style={{ fontSize: 13 }}>
                <strong>Origem:</strong> {originName}
              </p>
              <p style={{ fontSize: 13 }}>
                <strong>Destino:</strong> {destinationName}
              </p>
              {hasIntermediatePoints && (
                <p style={{ fontSize: 13 }}>
                  <strong>Pontos intermediários:</strong> {intermediatePointsRaw}
                </p>
              )}

              <div className="d-flex gap-2 mt-3">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => copyToClipboard(mapLink, "Link")}
                >
                  Copiar link
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => copyToClipboard(instructions, "Instruções")}
                >
                  Copiar instruções
                </Button>
                {vehicleType && (
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={openRoutingWithVehicle}
                  >
                    Reabrir roteirização
                  </Button>
                )}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
